import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import { I18nProvider, useI18n } from './i18n';
import AdminRoute from './components/AdminRoute';
import MainLayout from './components/MainLayout';
import RegistrationForm from './components/RegistrationForm';
import BracketDisplayPage from './pages/BracketDisplayPage';
import BracketPage from './pages/BracketPage';
import MemberListPage from './pages/MemberListPage';
import ParticipantListPage from './pages/ParticipantListPage';
import TournamentPage from './pages/TournamentPage';

function AppRoutes() {
  const { t } = useI18n();
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/tournament/display" element={<BracketDisplayPage />} />
        <Route element={<MainLayout />}>
          <Route path="/" element={<RegistrationForm />} />
          <Route
            path="/participants"
            element={
              <AdminRoute title={t('admin.titles.participants')}>
                <ParticipantListPage />
              </AdminRoute>
            }
          />
          <Route path="/tournament" element={<TournamentPage />} />

          {/* 관리자 전용: 메뉴에 노출하지 않고 URL 로만 접근 */}
          <Route path="/admin" element={<Navigate to="/admin/tournament" replace />} />
          <Route
            path="/admin/tournament"
            element={
              <AdminRoute title={t('admin.titles.tournament')}>
                <BracketPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/members"
            element={
              <AdminRoute title={t('admin.titles.members')}>
                <MemberListPage />
              </AdminRoute>
            }
          />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

function App() {
  return (
    <I18nProvider>
      <AppRoutes />
    </I18nProvider>
  );
}

export default App;
